<template>
  <div class="container">
    <div class="block">
      <div class="content-inner-wrap">
        <van-form
          :label-position="'right'"
          :submit-on-enter="false"
          label-width="88px"
          @submit="submitForm"
          ref="submitForm"
          :show-error="false"
          validate-first
          validate-trigger="onSubmit"
          :model="ruleForm"
        >
          <van-field
            label="工作室名称"
            name="name"
            :rules="rules.name"
            placeholder="请填写工作室名称"
            v-model="ruleForm.name"
          ></van-field>
          <van-field
            label="工作室ID"
            name="studio_id"
            v-model="ruleForm.studio_id"
          >
            <template slot="input">
              {{ ruleForm.studio_id }}
            </template>
          </van-field>
          <van-field
            label="工作室logo"
            name="head"
            v-model="ruleForm.fileList"
            :rules="rules.fileList"
          >
            <template slot="input">
              <my-el-upload
                :action="upload_url"
                class="upload-demo"
                :file-list="fileList"
                :on-remove="onRemove"
                :on-change="onChangeLogo"
                :before-upload="onBeforeUpload"
                name="image"
                accept="image/png,image/jpeg,image/bmp"
                list-type="picture"
              >
                <van-button size="small" class="uploadBtn" native-type="button">
                  <i class="icon icon-upload"></i><span>上传文件</span>
                </van-button>
                <div slot="tip" class="el-upload__tip">
                  <p>请上传工作室的LOGO图片，建议尺寸为：200*200</p>
                  <p>格式支持PNG、BMP、JPG，图片大小控制在10M以内</p>
                </div>
              </my-el-upload>
            </template>
          </van-field>
          <van-field
            label="工作室简介"
            maxlength="150"
            name="description"
            :rules="rules.description"
            type="textarea"
            rows="4"
            placeholder="请填写工作室简介"
            v-model="ruleForm.description"
          >
          </van-field>
          <van-field
            type="textarea"
            maxlength="150"
            name="notice"
            :rules="rules.notice"
            label="工作室公告"
            rows="4"
            placeholder="请填写工作室公告"
            v-model="ruleForm.notice"
          >
          </van-field>
          <van-field
            label="是否允许加入"
            name="allow_join"
            :rules="rules.allow_join"
            v-model="ruleForm.allow_join"
          >
            <template slot="input">
              <selector
                :selectArr="applyArr"
                @change="applyChange"
                :displayLabel="false"
                :currVal="parseInt(ruleForm.allow_join, 10)"
              >
              </selector>
            </template>
          </van-field>
          <van-button
            class="largeCenterBtn"
            type="primary"
            native-type="submit"
          >
            提交申请
          </van-button>
        </van-form>
        <van-button
          class="largeCenterBtn cancelBtn"
          type="primary"
          @click="$router.push({ name: 'settingsEntry' })"
          >取消</van-button
        >
        <p class="el-tips">修改的内容需要审核后才会生效</p>
      </div>
    </div>
  </div>
</template>
<script>
import MyUpload from '../../../../components/MyUpload';
import { getStudioDetail, updateStudioProfile } from '@/api/studio';
import { UPLOAD_URL, isValidFileSize } from '../../CONST';
import Selector from '../../../../components/Selector.vue';
export default {
  data() {
    let checkLen = (value, rule) => {
      console.log('checkLen start', rule, value);
      if (!value) {
        this.$toast.fail('请输入工作室名称');
        return false;
      }
      let len = value.length;
      let realLen = 0;
      let charCode = -1;
      for (let i = 0; i < len; i++) {
        charCode = parseInt(value.charCodeAt(i), 10);
        if (charCode >= 0 && charCode <= 128) {
          realLen += 1;
        } else {
          realLen += 3;
        }
      }
      if (realLen > (rule.max || 24)) {
        this.$toast.fail('已超出字数：中文最多8个或英文最多24个');
        return false;
      } else if (realLen < rule.min) {
        this.$toast.fail(
          `字数不得少于中文${Math.ceil(rule.min / 3)}个或英文${rule.min}个`,
        );
        return false;
      } else {
        return true;
      }
    };
    const checkBetween10and150 = value => {
      let len = (value + '').length;
      if (len >= 10 && len <= 150) return true;
      // this.$toast.fail(rule.message)
      return false;
    };
    return {
      applyArr: [
        { name: '允许申请', value: 1 },
        { name: '不允许申请', value: 0 },
      ],
      upload_url: UPLOAD_URL,
      ruleForm: {
        studio_id: 0,
        allow_join: 0,
        name: '',
        notice: '',
        head: '',
        description: '',
        fileList: '',
      },
      fileList: [],
      rules: {
        name: [
          { required: true, message: '请输入工作室名称', trigger: 'blur' },
          { min: 6, max: 24, trigger: 'blur', validator: checkLen },
        ],
        notice: [
          {
            required: true,
            min: 10,
            max: 150,
            validator: checkBetween10and150,
            message: '公告信息请控制在 10 至 150 字之间',
            trigger: 'change',
          },
        ],
        description: [
          {
            required: true,
            min: 10,
            max: 150,
            validator: checkBetween10and150,
            message: '简介信息请控制在 10 至 150 字之间',
            trigger: 'change',
          },
        ],
        fileList: [
          {
            type: 'string',
            required: true,
            message: '请上传工作室logo',
            trigger: 'change',
          },
        ],
        allow_join: [
          {
            type: 'number',
            required: true,
            message: '请选择是否允许申请',
            trigger: 'change',
          },
        ],
      },
    };
  },
  async created() {
    let studioBaseInfo = sessionStorage.getItem('studioBaseInfo');
    if (studioBaseInfo) {
      studioBaseInfo = JSON.parse(studioBaseInfo);
    } else {
      let res = await getStudioDetail();
      studioBaseInfo = res.data;
      sessionStorage.setItem('studioBaseInfo', JSON.stringify(studioBaseInfo));
    }
    let {
      name,
      studio_id,
      head,
      description,
      notice,
      allow_join,
    } = studioBaseInfo;
    this.ruleForm = {
      name,
      studio_id,
      head,
      description,
      notice,
      allow_join,
      fileList: JSON.stringify([{ name: '原logo', url: head }]),
    };
    this.fileList = [{ name: '原logo', url: head }];
  },
  components: {
    [MyUpload.name]: MyUpload,
    Selector,
  },
  methods: {
    onBeforeUpload(file) {
      return isValidFileSize(file.size, () =>
        this.$toast.fail('请限制文件大小在10M以内'),
      );
    },
    applyChange(val) {
      console.log('applyChange', val);
      this.ruleForm.allow_join = val.value;
    },
    onChangeLogo(file, fileList) {
      console.log('onChangeLogo', file, fileList, this.ruleForm.fileList);
      if (file.status === 'success' && file.response.code === 200) {
        let { image } = file.response.data;
        this.fileList = [{ name: file.name, url: image.cdn_url }];
        this.ruleForm.fileList = JSON.stringify([
          { name: file.name, url: image.cdn_url },
        ]);
      }
    },
    onRemove(file) {
      let delIndex = -1;
      this.ruleForm.fileList.forEach((val, index) => {
        if (val.url === file.url) delIndex = index;
      });
      if (delIndex >= 0) {
        this.ruleForm.fileList.splice(delIndex, 1);
      }
    },
    submitForm() {
      console.log('submitForm', this.$refs['submitForm'], this.ruleForm);
      let { fileList, name, notice, description, allow_join } = this.ruleForm;
      if (name && notice && description && fileList.length) {
        updateStudioProfile({
          json: 1,
          head: JSON.parse(fileList)[0].url,
          name,
          notice,
          description,
          allow_join: allow_join ? 1 : 0,
        }).then(res => {
          if (res.code === 0) {
            this.$toast.success('提交申请成功，请等待审核后生效');
            setTimeout(() => {
              this.$router.push({ name: 'settingsEntry' });
            }, 2000);
          }
        });
      } else {
        this.$toast.fail('请完善信息后提交');
      }
    },
  },
};
</script>
<style
  src="../../../../assets/styles/introduce-common.less"
  lang="less"
  scoped
></style>
<style lang="less" scoped>
.container {
  .content-inner-wrap {
    .van-form {
    }
    .el-tips {
      text-align: center;
      font-size: 23px;
      font-family: MicrosoftYaHei;
      color: #bfbfbf;
      line-height: 32px;
      margin: 80px auto;
    }
    // .largeBtnGroup{
    //   display: block;
    //   margin-top: 230px;
    // }
    ::v-deep .van-button {
      width: 502px;
      height: 70px;
      font-size: 28px;
      line-height: 38px;
      border-radius: 8px;
      &.cancelBtn {
        background: #d9d9d9;
        border-color: #d9d9d9;
      }
    }
  }
}
</style>
